import _ from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import actions from "@/actions";
import { Mark } from "@/sx-layout/models";

const MIN_SIZE = 0.5;
const MAX_SIZE = 2;
const STEP = 0.1;

export const useChangeMarkSize = (mark: Mark, onChangeSize: (m: Mark) => void) => {
  const dispatch = useDispatch();

  const [size, setSize] = useState<number>(mark.size);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setSize(mark.size);
  }, [mark.mark_id]);

  // 重機更新
  const updateMark = (value: number, m: Mark) => {
    setIsLoading(true);
    dispatch(
      actions.mark.updateMark(
        {
          ...m,
          size: value,
        },
        (data: Mark) => {
          onChangeSize(data);
          setIsLoading(false);
        },
        () => {
          setIsLoading(false);
        }
      )
    );
  };

  // サイズ変更
  const debounceUpdateMark = useMemo(() => _.debounce(updateMark, 300), []);
  const decrease = () => {
    if (size <= MIN_SIZE || isLoading) return;

    const newSize = round(size - STEP);
    setSize(newSize);
    debounceUpdateMark(newSize, mark);
  };
  const increase = () => {
    if (MAX_SIZE <= size || isLoading) return;

    const newSize = round(size + STEP);
    setSize(newSize);
    debounceUpdateMark(newSize, mark);
  };

  // 丸め処理
  const round = (value: number): number => {
    const factor = Math.pow(10, 1);
    return Math.round(value * factor) / factor;
  };

  return {
    size,
    decrease,
    increase,
    isLoading,
  };
};
